import { useQuery } from "@tanstack/react-query";

import { useSearchAgents } from "../../../hooks/useSearchAgents";

const useAgentDetailsQuery = ({ stateAgentData, decryptedPhone }) => {
  const { mutateAsync } = useSearchAgents();
  const shouldFetch = !stateAgentData && !!decryptedPhone;

  const query = useQuery({
    queryKey: ["agentDetails", decryptedPhone],
    queryFn: () => mutateAsync({ phone: decryptedPhone }),
    enabled: shouldFetch,
    retry: false,
  });

  return { ...query, shouldFetch };
};

export default useAgentDetailsQuery;
